import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './Backbutton.css';

function Backbutton() {

    const navigate = useNavigate();
    const location = useLocation();

    const handleBack = () => {

        if (location.state && location.state.from) {
            navigate(location.state.from);
        } else {
            navigate("/");
        }
    };

    return (
        <div className='back-btn-container'>
            <button
                className="back-btn"
                onClick={handleBack}
            >
                <FaArrowLeft />
            </button>
        </div>
    );
}

export default Backbutton;
